/**
 * Labstep
 *
 * @module components/EntityUserRoleRequirement/Action/Menu
 * @desc Action Menu for EntityUserRoleRequirement
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import { ActionMenu as ActionsMenu } from 'labstep-web/core/Action/Menu';
import type React from 'react';
import type { EntityUserRoleRequirementActionMenuProps } from './types';

export enum Action {
  delete = 'delete',
}

export const EntityUserRoleRequirementActionMenu: React.FC<
  EntityUserRoleRequirementActionMenuProps
> = ({ entityUserRoleRequirement, type, actions = [] }) => {
  return (
    <ActionsMenu type={type}>
      {actions.includes(Action.delete) && (
        <EntityActionDelete entity={entityUserRoleRequirement} />
      )}
    </ActionsMenu>
  );
};

EntityUserRoleRequirementActionMenu.defaultProps = {
  actions: [Action.delete],
  type: 'icon',
};
